import React, { useEffect, useState } from "react";
import "./listAllUsers.css";
import BdrModal from "../../../../components/BdrModal/BdrModal";
import BdrButton from "../../../../components/BdrButton/BdrButton";
import BdrInput from "../../../../components/BdrInput/BdrInput";
import {
  priceStrFormatter,
  removePriceStrFormatter,
} from "../../../../utils/formatters/priceStrFormatter";
import { useMutation } from "@apollo/client";
import {
  UPDATE_USER_WAGE,
  UPDATE_USER_SENIORITY_PAY,
} from "../../../../utils/GraphQL/mutations";

const clearObj = {
  userId: "",
  wage: "",
  seniority: "",
  payPercentage: "",
};

const WageModal = ({
  selectedUser,
  closeWageModal,
  handleSnack,
  updateUserWageCB,
}) => {
  const [updateObj, setUpdateObj] = useState({ ...clearObj });
  const [updateWage] = useMutation(UPDATE_USER_WAGE);
  const [updateSeniorityPay] = useMutation(UPDATE_USER_SENIORITY_PAY);

  useEffect(() => {
    if (selectedUser) {
      setUpdateObj({
        userId: selectedUser?._id,
        wage: selectedUser?.hourlyWage,
        seniority: selectedUser?.seniority != null ? String(selectedUser?.seniority) : "",
        payPercentage: selectedUser?.payPercentage || "",
      });
    }

    if (!selectedUser) {
      setUpdateObj({ ...clearObj });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);

  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;

    if (name === "wage") {
      value = removePriceStrFormatter(value);
    }

    setUpdateObj((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    const { data } = await updateWage({
      variables: {
        userId: updateObj.userId,
        wage: updateObj.wage,
      },
    });

    const seniorityStr = updateObj.seniority.trim() || null;
    const payPctStr = updateObj.payPercentage.trim() || null;

    const { data: spData } = await updateSeniorityPay({
      variables: {
        userId: updateObj.userId,
        seniority: seniorityStr,
        payPercentage: payPctStr,
      },
    });

    if (data?.editUserWage) {
      if (handleSnack) {
        handleSnack("User Updated!", 3000);
      }
      updateUserWageCB({ ...updateObj })
      closeWageModal()
      return;
    }

    if (spData?.updateUserSeniorityPay) {
      if (handleSnack) {
        handleSnack("User Updated!", 3000);
      }
      updateUserWageCB({ ...updateObj })
      closeWageModal()
      return;
    }

    if (handleSnack) {
      handleSnack("Something went wrong...", 3000);
    }
    closeWageModal()
  };

  return (
    <BdrModal
      open
      onClose={closeWageModal}
      title={`Update ${selectedUser?.firstName} ${selectedUser?.lastName}'s Info`}
      variant="panel"
      size="md"
      actions={
        <>
          <BdrButton onClick={closeWageModal}>Cancel</BdrButton>
          {/* solid: this modal sits on the saturated --bdr-grad-panel */}
          <BdrButton variant="confirm-solid" onClick={handleUpdate}>
            Update
          </BdrButton>
        </>
      }
    >
      <div className="lau-field-stack">
        <BdrInput
          type="tel"
          label="Wage"
          inputMode="numeric"
          name="wage"
          value={priceStrFormatter(updateObj?.wage)}
          onChange={handleChange}
        />
        <BdrInput
          type="number"
          label="Seniority"
          inputMode="numeric"
          min={1}
          name="seniority"
          value={updateObj?.seniority}
          onChange={handleChange}
          helper="1 is the highest."
        />
        <BdrInput
          type="text"
          label="Pay %"
          inputMode="decimal"
          name="payPercentage"
          value={updateObj?.payPercentage}
          onChange={handleChange}
          helper="A decimal fraction, e.g. 0.35 for 35%."
        />
      </div>
    </BdrModal>
  );
};

export default WageModal;
